export function EmailPreview({
  subject,
  body,
  buttonLabel,
  signature,
  headerImage,
  link,
}: {
  subject: string;
  body: string;
  buttonLabel: string;
  signature: string;
  headerImage: string | null;
  link?: string | undefined;
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-white">
      {headerImage && (
        <img
          src={headerImage}
          alt=""
          loading="lazy"
          className="h-24 w-full object-cover"
          width={1536}
          height={512}
        />
      )}
      <div className="p-6">
        <p className="text-[11px] font-semibold tracking-widest uppercase text-slate-400">
          {subject}
        </p>
        <div className="mt-4 space-y-3 text-sm leading-relaxed whitespace-pre-line text-slate-700">
          {body}
        </div>
        {link ? (
          <span className="mt-5 inline-block rounded-full bg-[#0b2044] px-5 py-2.5 text-xs font-semibold text-white">
            {buttonLabel}
          </span>
        ) : null}
        <p className="mt-6 border-t border-slate-200 pt-4 text-xs text-slate-500">{signature}</p>
      </div>
    </div>
  );
}
